import type { PriceBookContent } from '@/blocks/domain/types/BlockContent/PriceBookContent';
import type { BlockContentDto } from '@/blocks/application/mappers/blockMapper';
import { mergePriceBookColumnsWithDefaults } from '@/blocks/domain/helpers/priceBookColumnKeys';
import { mapPriceBookColumns } from '@/blocks/application/mappers/blockColumnsMapper';

export function mapPriceBookContent(dto: Extract<BlockContentDto, { kind: 'price_book' }>): PriceBookContent {
  const raw = dto as Extract<BlockContentDto, { kind: 'price_book' }> & { price_book_id?: unknown };
  const priceBookId = typeof raw.price_book_id === 'string' && raw.price_book_id.trim() ? raw.price_book_id : null;

  return {
    kind: 'price_book',
    title: dto.title,
    serviceItemIds: Array.isArray(dto.service_item_ids) ? dto.service_item_ids : [],
    columns: mergePriceBookColumnsWithDefaults(mapPriceBookColumns(dto)),
    priceBookId
  };
}

export function fromPriceBookContent(content: PriceBookContent): Extract<BlockContentDto, { kind: 'price_book' }> {
  const dto = {
    kind: 'price_book' as const,
    title: content.title,
    service_item_ids: content.serviceItemIds,
    columns: content.columns.map((col) => ({
      key: col.key,
      label: col.label,
      visible: col.visible,
      sortOrder: col.order
    })),
    ...(content.priceBookId ? { price_book_id: content.priceBookId } : {})
  };

  return dto as Extract<BlockContentDto, { kind: 'price_book' }>;
}
